module.exports = __webpack_public_path__ + "static/media/comment7_3.ab82632a.png";